module.exports = __webpack_public_path__ + "img/LogoEglobal_Color.495cabb3.png";